import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'block-text',
  templateUrl: './block-text.component.html',
  styleUrls: ['./block-text.component.sass']
})
export class BlockTextComponent implements OnInit {
  @Input() name: string;
  
  constructor() { }

  ngOnInit() {
  }

}
